
export const DISABLE_ROOM_IF_ON_CART = true;
export const ONLY_SAME_ZONE_BOOKABLE = true;
export const IF_BAR_THEN_ONLY_BAR = true;



// WEBPACK FOOTER //
// ./src/helpers/config.js